export const VisitStatusWithName = [
  { id: 0, name: 'Rescheduled visits', key: 'rescheduledVisits' },
  { id: 1, name: 'Cancelled visits', key: 'cancelledVisits' },
  { id: 2, name: 'Unassigned visits', key: 'unassignedVisits' },
];
